"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
/**
 * It holds configuration options
 * @property {string}   ga    - holds the google analytics configuration options
 */
var Configuration = /** @class */ (function () {
    function Configuration(options) {
        if (options === void 0) { options = {}; }
        Object.assign(this, options);
    }
    return Configuration;
}());
exports.Configuration = Configuration;
